import classNames from 'classnames'
import { PropsWithChildren } from 'react'

import styles from './QBRSectionThatCanBeDisabled.module.scss'

interface IQBRSectionAvailableWhenFinalizedProps extends PropsWithChildren {
  className?: string
}

export const QBRSectionAvailableWhenFinalized = ({
  children,
  className,
}: IQBRSectionAvailableWhenFinalizedProps) => (
  <div className={classNames(styles.availableWhenFinalized, className)}>{children}</div>
)
